import { List, Tooltip } from 'antd';
import React from 'react';
import { ObterComentarioPorItemId, DownloadAnexoLinhaItem } from '@app/api/minuta/ItemClausula';
import { usePromise, Button, Icon } from '@digital/ui';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export default function ListMensagem(linhaItemId: any) {


    const [getAllMensagem] = usePromise(
        () => (
            linhaItemId.linhaItemId ?
                ObterComentarioPorItemId(linhaItemId.linhaItemId)
                : Promise.resolve(undefined)),
        [linhaItemId.recarregarMensagem],
        [],
    );

    return (
        <div>
            <List
                itemLayout="horizontal"
                dataSource={getAllMensagem}
                renderItem={item => (
                    <List.Item>
                        {item.possuiArquivo ? (
                            <List.Item.Meta
                                title={
                                    <a href="#">
                                        {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                                    </a>
                                }
                                description={
                                    <>
                                        {item.mensagem}
                                        <br />
                                        <Button
                                            type="link"
                                            icon="arrows-circled_down_2"
                                            onClick={() => {
                                                DownloadAnexoLinhaItem(item.id);
                                            }}>
                                            Baixar Arquivo
                    </Button>
                                    </>
                                }
                                className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
                            />
                        ) : (
                                <List.Item.Meta
                                    title={
                                        <a href="#">
                                            {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao, "DD/MM/YYYY HH:mm:ss")).toLocaleString()}
                                        </a>
                                    }
                                    description={item.mensagem}
                                    className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
                                />
                            )}
                    </List.Item>
                )}
            />
        </div>
    );
}
